/* eslint camelcase: 0 */
/* eslint no-console: 0 */

import VueI18n from 'vue-i18n';
import { startsWith } from 'lodash';

import I18nMessagesDE from '@/i18n/de/common.json';
import I18nMessagesDE_CH from '@/i18n/de-CH/common.json';
import I18nMessagesEN from '@/i18n/en/common.json';
import I18nMessagesES from '@/i18n/es/common.json';
import I18nMessagesEL from '@/i18n/el/common.json';
import I18nMessagesFR from '@/i18n/fr/common.json';
import I18nEnumMessagesDE from '@/i18n/de/enums.json';
import I18nEnumMessagesDE_CH from '@/i18n/de-CH/enums.json';
import I18nEnumMessagesEN from '@/i18n/en/enums.json';
import I18nEnumMessagesES from '@/i18n/es/enums.json';
import I18nEnumMessagesEL from '@/i18n/el/enums.json';
import I18nEnumMessagesFR from '@/i18n/fr/enums.json';
import I18nValidationDE from '@/i18n/de/validation.json';
import I18nValidationEN from '@/i18n/en/validation.json';
import I18nValidationES from '@/i18n/es/validation.json';
import I18nValidationEL from '@/i18n/el/validation.json';
import I18nValidationFR from '@/i18n/fr/validation.json';
import Vue from 'vue';
import Vuelidate from 'vuelidate';

// eslint-disable-next-line no-undef
export default () => {
  Vue.use(VueI18n);

  const i18n = new VueI18n({
    locale: 'de', // set locale
    fallbackLocale: 'en',
    missing: (locale, key, vm = null) => {
      if (startsWith(key, 'input.')) {
        return '';
      } else {
        return key;
      }
    },
    silentTranslationWarn: true,
    messages: {
      de: {
        ...I18nMessagesDE,
        ...I18nEnumMessagesDE,
        ...I18nValidationDE,
      },
      'de-CH': {
        ...I18nMessagesDE_CH,
        ...I18nEnumMessagesDE_CH,
      },
      en: {
        ...I18nMessagesEN,
        ...I18nEnumMessagesEN,
        ...I18nValidationEN,
      },
      es: {
        ...I18nMessagesES,
        ...I18nEnumMessagesES,
        ...I18nValidationES,
      },
      'es-US': {
        ...I18nMessagesES,
        ...I18nEnumMessagesES,
        ...I18nValidationES,
      },
      el: {
        ...I18nMessagesEL,
        ...I18nEnumMessagesEL,
        ...I18nValidationEL,
      },
      fr: {
        ...I18nMessagesFR,
        ...I18nEnumMessagesFR,
        ...I18nValidationFR,
      },
    },
  });

  window.i18n = i18n;

  Vue.use(Vuelidate);
  // Vue.use(VeeValidate, {
  //   aria: true,
  //   classNames: {
  //     touched: 'v-validate-touched', // touched: indicates that the field has been touched or focused.
  //     untouched: 'v-validate-untouched', // untouched: indicates that the field has not been touched nor focused.
  //     valid: 'v-validate-valid', // valid: indicates that the field has been validated at least once and that it passed the validation.
  //     invalid: 'v-validate-invalid', // invalid: indicates that the field has been validated at least once and that it failed the validation.
  //     pristine: 'v-validate-pristine', // pristine: indicates that the field has not been manipulated.
  //     dirty: 'v-validate-dirty', // dirty: indicates that the field has been manipulated.
  //     pending: 'v-validate-pending', // pending: indicates that the field validation is in progress.
  //     validated: 'v-validate-validated', // validated: indicates that the field has been validated at least once.
  //     changed: 'v-validate-changed', // changed: indicates that the field value has been changed (strict check).
  //   },
  //   classes: true,
  //   delay: 0,
  //   dictionary: {
  //     de: deValidationMessages,
  //     'de-DE': deValidationMessages,
  //     'de-AT': deValidationMessages,
  //     'de-CH': deValidationMessages,
  //     en: enValidationMessages,
  //     'en-GB': enValidationMessages,
  //     'en-US': enValidationMessages,
  //     fr: frValidationMessages,
  //     nl: nlValidationMessages,
  //     es: esValidationMessages,
  //     'es-US': esValidationMessages,
  //     it: itValidationMessages,
  //   },
  //   errorBagName: 'errors', // change if property conflicts
  //   events: 'input|blur',
  //   fieldsBagName: 'fields',
  //   i18n: i18n, // the vue-i18n plugin instance
  //   i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  //   inject: true,
  //   // locale: 'de',
  //   strict: true,
  //   validity: false,
  // });

  return i18n;
};



// WEBPACK FOOTER //
// ./src/lib/util/i18n.js